import React, { useContext, useState } from "react";
import styles from "./Share.module.scss";
import { Context } from "../Store";
import { isMobile } from "react-device-detect";
import CopiedContext from "../CopiedContext";
import IsCopiedMessage from "./IsCopiedMessage";

const AnimText = ({ text }) => (
  <span className="btnText">
    <span>{text}</span>
  </span>
);

const Share = () => {
  const [state] = useContext(Context);
  const [showCopied, setShowCopied] = useState(false);
  const copied = { showCopied, setShowCopied };

  const getMediaShareURL = (country, guid) => {
    const domainMap = {
      us: "https://stories.us.flightclubdarts.com/",
      aus: "https://stories.flightclubdarts.com.au/",
      ie: "https://stories.flightclubdarts.ie/",
    };

    const baseURL = domainMap[country] || "https://stories.flightclubdarts.com/";
    return baseURL + guid;
  };

  const addUTMParams = (url, medium) => {
    const utmParams = new URLSearchParams({
      utm_source: "Stories",
      utm_medium: medium,
      utm_campaign: "share_with_friends",
    });

    const separator = url.includes("?") ? "&" : "?";
    return `${url}${separator}${utmParams.toString()}`;
  };

  const mediaShareURL = getMediaShareURL(state.country, state.guid);
  const nativeShareURL = addUTMParams(mediaShareURL, "native_share");
  const linkShareURL = addUTMParams(mediaShareURL, "link_share");
  const shareText = "Check out the Story of my Flight Club visit: ";

  const handleShareButton = async () => {
    if (isMobile && navigator.share) {
      try {
        await navigator.share({
          title: "Flight Club Stories",
          text: `${shareText}`,
          url: nativeShareURL,
        });
      } catch (e) {
        // user dismissed or share failed — fall through to clipboard
        if (e.name !== "AbortError") {
          await copyToClipboard();
        }
      }
    } else {
      await copyToClipboard();
    }
  };

  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(linkShareURL);
      setShowCopied(true);
    } catch {
      // clipboard API not available
    }
  };

  return (
    <CopiedContext.Provider value={copied}>
      <div className={styles.shareContainer}>
        <div>
          <div className={`${styles.shareLinkWrapper} shareLinkWrapper`}>
            <p> Let everyone see how it really went down</p>
            <button className="shareLink" onClick={handleShareButton}>
              <AnimText text="Share the glory" />
            </button>
          </div>
        </div>
        <IsCopiedMessage />
      </div>
    </CopiedContext.Provider>
  );
};

export default Share;
